module.exports = global["Backbone"] = require("-!./backbone-amd-1.0.0.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?Backbone!./public/javascripts/backbone-amd-1.0.0.js-exposed
// module id = 32
// module chunks = 0